import React from "react";
import { number, object } from "prop-types";
import MapShape from "components/MapShape/ForInitialSetup";
import { deviceSvgId } from "config/constants";
import { cacheItem } from "utils/localStorage";
import useGetFloorVertices from "hooks/useGetFloorVertices";

SettingChooseDevice.propTypes = {
  styles: object,
  mapLevel: number,
};

function SettingChooseDevice(props) {
  const { mapLevel } = props;

  const [thisDevice, setthisDevice] = React.useState(null);
  const [coordinateForDeviceSelection, setCoordinateForDeviceSelection] =
    React.useState([{ x: null, y: null }]);

  const { vertices: verticesList, deviceLocations } =
    useGetFloorVertices(mapLevel);

  // This for displaying chosen item on UI only
  const chosenDevice = React.useMemo(() => {
    const theMapItem = verticesList.find(({ id }) => id === thisDevice);
    return {
      id: theMapItem?.id,
      x: theMapItem?.cx,
      y: theMapItem?.cy,
    };
  }, [thisDevice]);

  const pinsListForDevices = React.useMemo(
    () =>
      chosenDevice.id || chosenDevice.id === 0
        ? [chosenDevice]
        : coordinateForDeviceSelection,
    [thisDevice, coordinateForDeviceSelection]
  );

  React.useEffect(() => {
    if (verticesList.length) {
      const setOfDeviceOptions = deviceLocations.map((eachId) => {
        const eachDevice = verticesList.find(({ id }) => id === eachId);
        return {
          id: eachDevice.id,
          x: eachDevice.cx,
          y: eachDevice.cy,
        };
      });

      setCoordinateForDeviceSelection(setOfDeviceOptions);
    }
  }, [verticesList]);

  return (
    <div>
      <div className="form-row pb-5 align-items-center">
        Chọn vị trí thiết bị
        {thisDevice && (
          <button
            type="button"
            className="btn btn-primary ml-3"
            onClick={() => cacheItem(deviceSvgId, thisDevice)}
          >
            Submit
          </button>
        )}
      </div>

      <MapShape
        floorIndex={mapLevel}
        pinsList={pinsListForDevices}
        onSelect={(eleId) => setthisDevice(eleId)}
      />
    </div>
  );
}

export default SettingChooseDevice;
